import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

@Injectable()
export class RpsPrestadoresOdontologicosService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(regans: string, competencia: string, competencia_final: string, registro_rps?: number) {
    return this.simuladorGoApi
      .fetchRpsPrestadoresOdontologicos({ regans, competencia, competencia_final, registro_rps })
      .pipe(map(data => data.items));
  }
}
